import { config } from '../../api/config';

export const adminPermissionDefinitions = [
  {
    key: 'admins',
    label: config.PAGES.admins,
    permissionIds: [
      config.PERMISSIONS.admins.view,
      config.PERMISSIONS.admins.edit,
    ],
  },
  {
    key: 'locations',
    label: config.PAGES.locations,
    permissionIds: [
      config.PERMISSIONS.locations.view,
      config.PERMISSIONS.locations.edit,
    ],
    supportsLocationScope: true,
    supportsFailureNotifications: true,
  },
  {
    key: 'orders',
    label: config.PAGES.orders,
    permissionIds: [
      config.PERMISSIONS.orders.view,
      config.PERMISSIONS.orders.edit,
    ],
  },
  {
    key: 'clients',
    label: config.PAGES.clients,
    permissionIds: [
      config.PERMISSIONS.clients.view,
      config.PERMISSIONS.clients.edit,
    ],
  },
  {
    key: 'invoices',
    label: config.PAGES.invoices,
    permissionIds: [
      config.PERMISSIONS.invoices.view,
      config.PERMISSIONS.invoices.edit,
    ],
  },
  {
    key: 'receipts',
    label: config.PAGES.receipts,
    permissionIds: [
      config.PERMISSIONS.receipts.view,
      config.PERMISSIONS.receipts.edit,
    ],
  },
  {
    key: 'membershipOrders',
    label: config.PAGES.membershipOrders,
    permissionIds: [
      config.PERMISSIONS.membershipOrders.view,
      config.PERMISSIONS.membershipOrders.edit,
    ],
  },
  {
    key: 'memberships',
    label: config.PAGES.memberships,
    permissionIds: [
      config.PERMISSIONS.memberships.view,
      config.PERMISSIONS.memberships.edit,
    ],
  },
  {
    key: 'discounts',
    label: config.PAGES.discounts,
    permissionIds: [
      config.PERMISSIONS.discounts.view,
      config.PERMISSIONS.discounts.edit,
    ],
  },
  {
    key: 'businessClients',
    label: config.PAGES.businessClients,
    permissionIds: [
      config.PERMISSIONS.businessClients.view,
      config.PERMISSIONS.businessClients.edit,
    ],
  },
  {
    key: 'textile',
    label: config.PAGES.textile,
    permissionIds: [config.PERMISSIONS.textile.view],
  },
  {
    key: 'coupons',
    label: config.PAGES.coupons,
    permissionIds: [
      config.PERMISSIONS.coupons.view,
      config.PERMISSIONS.coupons.edit,
    ],
  },
  {
    key: 'monitoring',
    label: config.PAGES.monitoring,
    permissionIds: [
      config.PERMISSIONS.monitoring.view,
      config.PERMISSIONS.monitoring.edit,
    ],
  },
  {
    key: 'auditLogs',
    label: config.PAGES.auditLogs,
    permissionIds: [config.PERMISSIONS.auditLogs.view],
  },
  {
    key: 'loyaltyProgram',
    label: 'Lojalumo programa',
    permissionIds: [
      config.PERMISSIONS.loyaltyProgram.view,
      config.PERMISSIONS.loyaltyProgram.edit,
    ],
  },
  {
    key: 'affiliate',
    label: config.PAGES.affiliate,
    permissionIds: [
      config.PERMISSIONS.affiliate.view,
      config.PERMISSIONS.affiliate.edit,
    ],
  },
  {
    key: 'physicalCards',
    label: config.PAGES.physicalCards,
    permissionIds: [
      config.PERMISSIONS.physicalCards.view,
      config.PERMISSIONS.physicalCards.edit,
    ],
  },
];

export const businessRoles = [
  {
    name: 'Nepasirinkta',
    value: 0,
  },
  {
    name: config.BUSINESS_ROLES.MANAGER.name,
    value: config.BUSINESS_ROLES.MANAGER.value,
  },
];
